import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { EmployeesCustomTemplateOptionsModel } from '../../models/EmployeesCustomTemplateOptionsModel';
import { EmployeeTemplateOptionModel } from '../../models/EmployeeTemplateOptionModel';
import { ImportResponse } from '../../Pages/ProductsPage/types';

interface IFileImportService {
  getEmployeeTemplateOptions: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<EmployeeTemplateOptionModel[]>>;
  downloadEmployeeTemplate: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadTransactionTemplate: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadCardTemplate: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadOrderTemplate: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadTimesheetTemplate: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  saveEmployeesImport: (
    data: FormData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<number>>;
  importTransactions: (
    data: FormData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<string>>;
  importCards: (
    data: FormData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<string>>;
  importOrders: (
    data: FormData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ImportResponse>>;
  importTimesheet: (
    data: FormData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ImportResponse>>;
  saveEmployeeTemplate: (
    data: EmployeesCustomTemplateOptionsModel[],
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  downloadTransactionsReport: (
    path: string,
    fileName: string,
    fileExtention: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadOrdersReport: (
    path: string,
    fileName: string,
    fileExtention: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadCardsReport: (
    path: string,
    fileName: string,
    fileExtention: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadTimesheetReport: (
    path: string,
    fileName: string,
    fileExtention: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
}

export const fileImportService: IFileImportService = {
  getEmployeeTemplateOptions(
    axiosConfig,
  ): Promise<HttpResponse<EmployeeTemplateOptionModel[]>> {
    return ajax.get<EmployeeTemplateOptionModel[]>(
      `${config.benefitApiUrl}/employee-template-options`,
      axiosConfig,
    );
  },
  downloadEmployeeTemplate(axiosConfig): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-employee-template`,
      'Sablon import angajati',
      'xlsx',
      axiosConfig,
    );
  },
  downloadTransactionTemplate(axiosConfig): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-transaction-template`,
      'Sablon import buget',
      'xlsx',
      axiosConfig,
    );
  },
  downloadCardTemplate(axiosConfig): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-cards-template`,
      'Sablon import carduri',
      'xlsx',
      axiosConfig,
    );
  },
  downloadOrderTemplate(axiosConfig): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-orders-template`,
      'Sablon import comenzi',
      'xlsx',
      axiosConfig,
    );
  },
  downloadTimesheetTemplate(axiosConfig): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-timesheet-template`,
      'Sablon import pontaj',
      'xlsx',
      axiosConfig,
    );
  },
  saveEmployeesImport(data, axiosConfig): Promise<HttpResponse<number>> {
    return ajax.post<number>(
      `${config.benefitApiUrl}/upload-employees-file`,
      data,
      axiosConfig,
    );
  },
  importTransactions(data, axiosConfig): Promise<HttpResponse<string>> {
    return ajax.post(`${config.benefitApiUrl}/import-transactions`, data, {
      ...axiosConfig,
    });
  },
  importCards(data, axiosConfig): Promise<HttpResponse<string>> {
    return ajax.post(`${config.benefitApiUrl}/import-cards`, data, {
      ...axiosConfig,
    });
  },
  importOrders(data, axiosConfig): Promise<HttpResponse<ImportResponse>> {
    return ajax.post(`${config.benefitApiUrl}/import-orders`, data, {
      ...axiosConfig,
    });
  },
  importTimesheet(data, axiosConfig): Promise<HttpResponse<ImportResponse>> {
    return ajax.post(`${config.benefitApiUrl}/import-timesheet`, data, {
      ...axiosConfig,
    });
  },
  saveEmployeeTemplate(data, axiosConfig): Promise<HttpResponse<boolean>> {
    return ajax.put<boolean>(
      `${config.benefitApiUrl}/save-employee-template`,
      data,
      axiosConfig,
    );
  },
  downloadTransactionsReport(
    fileCode,
    fileName,
    fileExtention,
    axiosConfig,
  ): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-transaction-report/${fileCode}`,
      fileName,
      fileExtention,
      axiosConfig,
    );
  },
  downloadCardsReport(
    fileCode,
    fileName,
    fileExtention,
    axiosConfig,
  ): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-cards-report/${fileCode}`,
      fileName,
      fileExtention,
      axiosConfig,
    );
  },
  downloadOrdersReport(
    fileCode,
    fileName,
    fileExtention,
    axiosConfig,
  ): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-order-report/${fileCode}`,
      fileName,
      fileExtention,
      axiosConfig,
    );
  },
  downloadTimesheetReport(
    fileCode,
    fileName,
    fileExtention,
    axiosConfig,
  ): Promise<HttpResponse<null>> {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-timesheet-report/${fileCode}`,
      fileName,
      fileExtention,
      axiosConfig,
    );
  },
};
